<script>
  /* global agGrid */
  import GRID_LOCALE_CS from '../js/gridLocaleCs.js';
  import GRID_LOCALE_EN from '../js/gridLocaleEn.js';
  import { onMount } from 'svelte';

  export let value;
  export let lang = undefined;
  export let mode = undefined;

  let rocketHandElement;

  let gridOptions;

  function getOptions () {
    return {
      theme: 'legacy',
      defaultColDef: {
        width: 90,
        sortable: true,
        filter: true,
        filterParams: {
          maxNumConditions: 1,
          filterOptions: ['contains'],
        },
      },
      columnDefs: [
        {
          headerName: lang !== 'en' ? 'Účastník' : 'Participant',
          // eslint-disable-next-line no-magic-numbers
          children: [
            {
              valueGetter: 'node.rowIndex + 1',
              headerName: '##',
              width: 45,
              cellDataType: 'number',
              type: 'numericColumn',
              pinned: true,
              filter: false,
            },
            {
              field: 'name',
              headerName: lang !== 'en' ? 'Jméno' : 'Name',
              width: 135,
              pinned: true,
              cellStyle: { fontWeight: 'bold' },
            },
          ],
        },
        {
          field: 'speed',
          headerName: lang !== 'en' ? 'Rychlost' : 'Speed',
          width: 135,
          cellDataType: 'number',
          type: 'numericColumn',
          filterParams: {
            filterOptions: ['equals', 'inRange', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
          },
          valueFormatter: params => `${params.value} km/h`,
        },
        {
          field: 'field',
          headerName: lang !== 'en' ? 'Hřiště' : 'Field',
          valueFormatter: params => params.value.toUpperCase(),
        },
        {
          flex: 1,
          filter: false,
          sortable: false,
          suppressMovable: true,
        },
      ],
      animateRows: true,
      accentedSort: true,
      rowData: value,
      localeText: lang !== 'en' ? GRID_LOCALE_CS : GRID_LOCALE_EN,
    };
  }

  onMount(() => {
    gridOptions = getOptions();

    gridOptions = agGrid.createGrid(rocketHandElement, gridOptions);
  });

  $: if (gridOptions && lang) {
    gridOptions.destroy();
    gridOptions = getOptions();

    gridOptions = agGrid.createGrid(rocketHandElement, gridOptions);
  }
</script>

<div class='rocket-hand ag-theme-balham' bind:this={rocketHandElement}
  class:ag-theme-balham-dark={mode !== 'light'}/>

<style>
  .rocket-hand {
    width: 100%;
    height: 100%;
  }

  :global(.ag-root-wrapper) {
    border-radius: var(--radius-lg);
  }
</style>
